var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M10 0c.46 0 .833.373.833.833V2.5a.833.833 0 1 1-1.666 0V.833C9.167.373 9.54 0 10 0m7.073 2.927a.833.833 0 0 1 0 1.179l-1.184 1.183a.833.833 0 0 1-1.178-1.178l1.183-1.184a.833.833 0 0 1 1.179 0M6.667 10a3.333 3.333 0 1 1 6.666 0 3.333 3.333 0 0 1-6.666 0M10 5a5 5 0 1 0 0 10 5 5 0 0 0 0-10M0 10c0-.46.373-.833.833-.833H2.5a.833.833 0 1 1 0 1.666H.833A.833.833 0 0 1 0 10m17.5-.833a.833.833 0 0 0 0 1.666h1.667a.833.833 0 0 0 0-1.666zM5.29 14.71a.833.833 0 0 1 0 1.178l-1.184 1.184a.833.833 0 0 1-1.179-1.179l1.184-1.183a.833.833 0 0 1 1.178 0m9.42 0a.834.834 0 0 1 1.18 0l1.183 1.183a.833.833 0 0 1-1.179 1.179l-1.183-1.184a.833.833 0 0 1 0-1.178M4.107 2.927a.833.833 0 1 0-1.179 1.179l1.184 1.183a.833.833 0 1 0 1.178-1.178zM10.833 17.5a.833.833 0 0 0-1.666 0v1.667a.833.833 0 0 0 1.666 0z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.1fa8abbd860aab3690142a723cc72e9c.svg";
export { ForwardRef as ReactComponent };